module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators 3.e04e4b9c.jpg";